// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"12":"cards","332":"Post","443":"about"}[chunkId] + "." + {"12":"17e47347","332":"ef1883d1","443":"f7acc9e7"}[chunkId] + ".css";
};